import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { info } from "@/api/system/tenant";
import { getCaptcha } from "@/api/user";
import { getTopUrl } from "@/util/util";
export default {
  name: "userlogin",
  data: function data() {
    return {
      tenantMode: this.website.tenantMode,
      loginForm: {
        //租户ID
        tenantId: "123369",
        //用户名
        username: "",
        //密码
        password: "",
        //账号类型
        type: "account",
        //验证码的值
        code: "",
        //验证码的索引
        key: "",
        //预加载白色背景
        image: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      },
      loginRules: {
        tenantId: [{
          required: false,
          message: "请输入租户ID",
          trigger: "blur"
        }],
        username: [{
          required: true,
          message: "请输入账号（手机号）",
          trigger: "change"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "change"
        }, {
          min: 1,
          message: "密码长度最少为6位",
          trigger: "change"
        }]
      },
      toUrl: '',
      passwordType: "password"
    };
  },
  created: function created() {
    this.getTenant();
    this.refreshCode();
  },
  mounted: function mounted() {},
  computed: _objectSpread({}, mapGetters(["tagWel"])),
  props: [],
  methods: {
    blurname: function blurname(e) {
      if (e.target.value === 'hsyktadmin' || e.target.value === '13305716963') {
        this.$set(this.loginForm, "tenantId", "000000");
      }
    },
    checkother: function checkother(val) {
      this.$set(this.loginForm, "tenantId", val);
    },
    forgetPass: function forgetPass() {
      this.$router.push({
        path: '/forgetPassword'
      });
    },
    refreshCode: function refreshCode() {
      var _this = this;

      getCaptcha().then(function (res) {
        var data = res.data;
        _this.loginForm.key = data.key;
        _this.loginForm.image = data.image;
      });
    },
    showPassword: function showPassword() {
      this.passwordType === "" ? this.passwordType = "password" : this.passwordType = "";
    },
    handleLogin: function handleLogin() {
      var _this2 = this;

      var that = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          var loading = _this2.$loading({
            lock: true,
            text: '登录中,请稍后。。。',
            spinner: "el-icon-loading"
          });

          _this2.$store.dispatch("LoginByUsername", _this2.loginForm).then(function (res) {
            _this2.$store.dispatch("getplatformDetail", res.user_id).then(function (res) {}); // that.$router.push({path: '/overView/omCenter'});


            that.$router.push({
              path: that.toUrl || '/overView/omCenter'
            });
            console.log(that.toUrl, '---path: this.toUrlpath: this.toUrl'); //  this.$router.push({path: this.toUrl || this.tagWel.value});

            loading.close();
          }).catch(function () {
            loading.close();

            _this2.refreshCode();
          });
        }
      });
    },
    getTenant: function getTenant() {
      var _this3 = this;

      var domain = getTopUrl(); // 临时指定域名，方便测试
      //domain = "https://bladex.vip";

      info(domain).then(function (res) {
        var data = res.data;

        if (data.success && data.data.tenantId) {
          _this3.tenantMode = false;
          _this3.loginForm.tenantId = data.data.tenantId;
          _this3.$parent.$refs.login.style.backgroundImage = "url(".concat(data.data.backgroundUrl, ")");
          _this3.$parent.info = data.data.companyTitle;
          _this3.$parent.title = data.data.companyTitle;
          _this3.$parent.logo = data.data.companyLogo;
          _this3.toUrl = data.data.jumpUrl;
          document.title = data.data.companyTitle;
          console.log(_this3.$parent, '---');
        }
      });
    }
  }
};